import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FrameSlider from '../slider/FrameSlider';
import Slide from '../slider/Slide';
import { PROMPT_TYPE } from '../../../../constants';

import scss from './FrameCard.module.scss';

function FrameCard({ frameData, onPreview, onLike, onDownload, onShowSourceImage }) {
  const { t } = useTranslation('id8');
  const [currentImage, setCurrentImage] = useState(0);

  const { images, generating, promptType } = frameData;
  const { ideaHeadline, copy, advertisingStatement } = images?.[currentImage] ?? EMPTY_IMAGE;

  const handlePreview = () => {
    onPreview({ frameData, initialIndex: currentImage });
  };

  const handleChangeImage = (_, next) => {
    setCurrentImage(next);
  };

  const handleShowSourceImage = () => {
    onShowSourceImage(frameData);
  };

  return (
    <div className={scss.card}>
      <FrameSlider
        onPreview={handlePreview}
        images={images}
        onLike={onLike}
        onDownload={onDownload}
        onSwipe={handleChangeImage}
        isGenerating={generating}
        {...(promptType === PROMPT_TYPE.RECREATE ? { onShowSourceImage: handleShowSourceImage } : {})}
        Slide={Slide}
      />

      <div className={scss.content}>
        <span className={scss.title}>
          <b>{t('ideaHeadline')}: </b>
          {ideaHeadline}
        </span>

        <div className={scss.textContent}>
          <span className={scss.subTitle}>{copy}</span>
          <span className={scss.subTitle}>{advertisingStatement}</span>
        </div>
      </div>
    </div>
  );
}

export default memo(FrameCard, (prevProps, nextProps) => {
  return (
    prevProps.frameData.id === nextProps.frameData.id &&
    prevProps.frameData.generating === nextProps.frameData.generating &&
    prevProps.frameData.images === nextProps.frameData.images
  );
});

export const EMPTY_IMAGE = { ideaHeadline: '-/-', copy: '-/-', advertisingStatement: '-/-' };
